import { render, staticRenderFns } from "./SearchResultsIndividual.vue?vue&type=template&id=00d61dea&scoped=true&"
import script from "./SearchResultsIndividual.vue?vue&type=script&lang=js&"
export * from "./SearchResultsIndividual.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsIndividual.vue?vue&type=style&index=0&id=00d61dea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d61dea",
  null
  
)

export default component.exports